import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { getFirebaseBackend } from '../../authUtils';

import { User } from '../models/auth.models';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {

    user: User;
  
    private currentUserSubject: BehaviorSubject<User>;
    private currentUser: Observable<User>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    /**
     * Returns the current user
     */
     public loggedInUser(): User {
         var ret:User;
        this.currentUser.subscribe(val=>{
            ret = val;
            
        })
          return ret;
      }
      
    

    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     
    login(email: string, password: string) {
        return getFirebaseBackend().loginUser(email, password).then((response: any) => {
            const user = response;
            return user;
        });
    }
    */
    login(mobile: string, password: string) {
        return this.http.post<any>(`${environment.baseUrl}Login/Login`, { mobile, password })
            .pipe(map(user => {
                // login successful if there's a jwt token in the response
                //user && user.token
                // if (user.user[0].usercode!=null ) {
                //     // store user details and jwt token in local storage to keep user logged in between page refreshes
                //     sessionStorage.setItem('currentUser', JSON.stringify(user.user[0]));
                //     this.currentUserSubject.next(user.user[0]);
                    
                // }
                // return user.user[0];
                if (user.usercode!=null ) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    sessionStorage.setItem('currentUser', JSON.stringify(user));
                    localStorage.setItem("permissions", JSON.stringify(user.permissions));
                    this.currentUserSubject.next(user);
                    
                }
                return user;

            }));
    }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(email: string, password: string) {
        return getFirebaseBackend().registerUser(email, password).then((response: any) => {
            const user = response;
            return user;
        });
    }

    /**
     * Reset password
     * @param email email
     */
    resetPassword(email: string) {
        return getFirebaseBackend().forgetPassword(email).then((response: any) => {
            const message = response.data;
            return message;
        });
    }
    hasPermission(permission: string): boolean {
        const perms = JSON.parse(localStorage.getItem("permissions") || "[]");
        return perms.includes(permission);
    }


    /**
     * Logout the user
     */
    logout() {
        // logout the user
        getFirebaseBackend().logout();
    }
}

